import * as React from "react";

function WWWIconSvg(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} viewBox="0 0 32 32">
			<path d="M16 0a16 16 0 1016 16A16 16 0 0016 0z" />
			<path
        className={props.className}
				d="M4.905 13.267l.436 2.233c.111.57.223 1.174.313 1.8h.022c.112-.626.269-1.252.4-1.789l.582-2.247H8l.547 2.18c.146.615.291 1.23.4 1.856h.022c.078-.626.19-1.241.313-1.867l.47-2.169h1.666l-1.673 5.47h-1.6l-.513-1.924a20.313 20.313 0 01-.346-1.7h-.022a12.731 12.731 0 01-.358 1.7l-.548 1.923H4.76l-1.588-5.467h1.733zM13.608 13.267l.436 2.236c.111.57.223 1.174.313 1.8h.022c.112-.626.269-1.252.4-1.789l.582-2.247H16.7l.547 2.18c.146.615.291 1.23.4 1.856h.022c.078-.626.19-1.241.313-1.867l.47-2.169h1.666l-1.678 5.467h-1.6l-.514-1.923a20.313 20.313 0 01-.346-1.7h-.023a12.731 12.731 0 01-.358 1.7l-.548 1.923h-1.6l-1.588-5.467h1.733zM22.31 13.267l.436 2.236c.111.57.223 1.174.313 1.8h.022c.112-.626.269-1.252.4-1.789l.582-2.247h1.342l.547 2.18c.146.615.291 1.23.4 1.856h.022c.078-.626.19-1.241.313-1.867l.47-2.169h1.666l-1.673 5.467h-1.6l-.514-1.923a20.313 20.313 0 01-.346-1.7h-.023a12.731 12.731 0 01-.358 1.7l-.548 1.923h-1.6l-1.588-5.467h1.737z"
			/>
		</svg>
	);
}

export default WWWIconSvg;
